/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { ReportExportDialog } from "../../../components/report_export_dialog";

/**
 * The shared format picker with the Labor report's own title and test id. Every other prop
 * passes straight through.
 */
export const LaborReportExportDialog = ({
  title = "Export Labor Report",
  testId = "labor-report-export-dialog",
  ...props
}) => <ReportExportDialog {...props} title={title} testId={testId} />;
